"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TableRow = exports.SubTitle = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _jsxRuntime = require("react/jsx-runtime");

var RatesAndTermsDiv = _styledComponents["default"].div.withConfig({
  displayName: "RatesAndTermsDiv",
  componentId: "sc-ttx7nx-0"
})(["margin-top:8px;margin-bottom:14px;"]);

var RatesTable = _styledComponents["default"].table.withConfig({
  displayName: "RatesTable",
  componentId: "sc-ttx7nx-1"
})(["margin-top:16px;width:100%;@media (", "){margin-bottom:24px;}"], _baseReactComponents.theme.forLargerThanPhone);

var TableRow = _styledComponents["default"].tr.withConfig({
  displayName: "TableRow",
  componentId: "sc-ttx7nx-2"
})(["display:flex;justify-content:space-between;&:nth-child(odd){background:", ";}"], _baseReactComponents.theme.neutral100);

exports.TableRow = TableRow;

var RowTitle = _styledComponents["default"].td.withConfig({
  displayName: "RowTitle",
  componentId: "sc-ttx7nx-3"
})(["padding:8px 0 8px 16px;width:39%;align-self:flex-start;"]);

var RowDescription = _styledComponents["default"].td.withConfig({
  displayName: "RowDescription",
  componentId: "sc-ttx7nx-4"
})(["padding:8px 16px 8px 0;width:60%;"]);

var SubTitle = (0, _styledComponents["default"])(_baseReactComponents.Copy).attrs(function () {
  return {
    size: 'md'
  };
}).withConfig({
  displayName: "SubTitle",
  componentId: "sc-ttx7nx-5"
})([""]);
exports.SubTitle = SubTitle;

var RatesTableRow = function RatesTableRow(_ref) {
  var title = _ref.title,
      description = _ref.description;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(TableRow, {
    "data-testid": "rates-and-terms:row",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(RowTitle, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
        size: "xs",
        shouldScaleFont: true,
        light: true,
        bold: true,
        children: title
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(RowDescription, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
        size: "xs",
        shouldScaleFont: true,
        light: true,
        children: description
      })
    })]
  });
};

var Rates = function Rates(_ref2) {
  var _ref2$creditCardOffer = _ref2.creditCardOffer,
      creditCardOffer = _ref2$creditCardOffer === void 0 ? {} : _ref2$creditCardOffer;
  var _creditCardOffer$aprs = creditCardOffer.aprs,
      aprs = _creditCardOffer$aprs === void 0 ? {} : _creditCardOffer$aprs,
      _creditCardOffer$fees = creditCardOffer.fees,
      fees = _creditCardOffer$fees === void 0 ? {} : _creditCardOffer$fees,
      _creditCardOffer$rewa = creditCardOffer.rewards,
      rewards = _creditCardOffer$rewa === void 0 ? {} : _creditCardOffer$rewa;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(RatesAndTermsDiv, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SubTitle, {
        light: true,
        bold: true,
        children: "Rates and Fees"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(RatesTable, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("tbody", {
        children: [Object.entries(aprs).filter(function (_ref3) {
          var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
              apr = _ref4[1];

          return !!apr;
        }).map(function (_ref5) {
          var _ref6 = (0, _slicedToArray2["default"])(_ref5, 2),
              key = _ref6[0],
              _ref6$ = _ref6[1],
              title = _ref6$.title,
              description = _ref6$.description;

          return /*#__PURE__*/(0, _jsxRuntime.jsx)(RatesTableRow, {
            title: title,
            description: description
          }, key);
        }), Object.entries(fees).filter(function (_ref7) {
          var _ref8 = (0, _slicedToArray2["default"])(_ref7, 2),
              fee = _ref8[1];

          return !!fee;
        }).map(function (_ref9) {
          var _ref10 = (0, _slicedToArray2["default"])(_ref9, 2),
              key = _ref10[0],
              _ref10$ = _ref10[1],
              title = _ref10$.title,
              description = _ref10$.description;

          return /*#__PURE__*/(0, _jsxRuntime.jsx)(RatesTableRow, {
            title: title,
            description: description
          }, key);
        }), Object.entries(rewards).filter(function (_ref11) {
          var _ref12 = (0, _slicedToArray2["default"])(_ref11, 2),
              reward = _ref12[1];

          return !!reward;
        }).map(function (_ref13) {
          var _ref14 = (0, _slicedToArray2["default"])(_ref13, 2),
              key = _ref14[0],
              _ref14$ = _ref14[1],
              title = _ref14$.title,
              description = _ref14$.description;

          return /*#__PURE__*/(0, _jsxRuntime.jsx)(RatesTableRow, {
            title: title,
            description: description
          }, key);
        })]
      })
    })]
  });
};

var StyledRates = (0, _styledComponents["default"])(Rates).withConfig({
  displayName: "StyledRates",
  componentId: "sc-ttx7nx-6"
})([""]);
var _default = StyledRates;
exports["default"] = _default;
//# sourceMappingURL=rates.js.map